import { Reducer } from "redux";
import { ActionTypes, IMessageToasterState, MessageToasterActions } from "./MessageToasterActionTypes";

export const initialState: IMessageToasterState = {
    message: undefined
};

const reducer: Reducer<IMessageToasterState> = (state: IMessageToasterState = initialState, action: MessageToasterActions) => {
    switch (action.type) {
        case ActionTypes.SHOW_MESSAGE:
        case ActionTypes.CLEAR_MESSAGE:
            return { ...state, message: action.data };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/Store/MessageToaster/MessageToasterReducer.tsx